import Immutable from 'immutable'

type TerminalInfoProps = {
    printMaxWidth: number | null
    printMaxHeight: number | null
    terminalId: string | null
    terminalType: string | null

}

const TerminalInfoRecord = Immutable.Record({
    printMaxWidth: null,
    printMaxHeight: null,
    terminalId: null,
    terminalType: null,
})

export default class TerminalInfo extends TerminalInfoRecord implements Readonly<TerminalInfoProps>
{
    // printMaxWidth: number | null
    // printMaxHeight: number | null
    // terminalId: string | null
    // terminalType: string | null
}
